import { Component, input, InputSignal } from '@angular/core';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';

@Component({
  selector: 'app-bus-loader',
  standalone: true,
  imports: [
    LottieComponent
  ],
  templateUrl: './bus-loader.component.html',
  styleUrls: ['./bus-loader.component.scss'],
})
export class BusLoaderComponent {
  public title: InputSignal<string> = input<string>('');
  public subtitle: InputSignal<string> = input<string>('');
  
  public options: AnimationOptions = {
    path: '/assets/animations/bus-loader.json',
  };
}
